import React, { useEffect } from 'react'

export default function Lightbox({ src, onClose }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose()
    }
    if (src) document.body.style.overflow = 'hidden'
    else document.body.style.overflow = ''
    window.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', onKey)
    }
  }, [src, onClose])

  if (!src) return null

  return (
    <div className={`lightbox show`} role="dialog" aria-label="Image preview" onClick={(e) => { if (e.target.classList.contains('lightbox')) onClose() }}>
      <img id="lightbox-img" src={src} alt="Tweet media preview" />
      <button className="close" id="lightbox-close" aria-label="Close" onClick={onClose}>×</button>
    </div>
  )
}
